import { REST_URI } from 'lib/appConfig';
import session from 'lib/api/links/session';
import { getAuthHeaders } from 'lib/api/links/helpers';

/**
 * POST /operator-view/labor-ticket/{machineRef}/start-jobs
 * @param {number} machineRef
 * @param {Array<{ workOrderOperationRef: number, activityMode: string }>} jobs
 */
export const postMultiJobStartJobs = async (machineRef, jobs) => {
  const apiKey = await session.getApiKey();
  const res = await fetch(
    `${REST_URI}/operator-view/labor-ticket/${machineRef}/start-jobs`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(apiKey),
      },
      body: JSON.stringify({ jobs }),
    }
  );
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `start-jobs failed: ${res.status}`);
  }
};

/**
 * Change job for a program event via merge.
 * POST /operator-view/labor-ticket/{machineRef}/program-events/{eventId}/merge
 * @param {number} machineRef
 * @param {number|string} eventId  – representative programEventRef
 * @param {number} targetWorkOrderOperationRef – the new WOO to assign
 */
export const postChangeJobForEvent = async (
  machineRef,
  eventId,
  targetWorkOrderOperationRef
) => {
  const apiKey = await session.getApiKey();
  const res = await fetch(
    `${REST_URI}/operator-view/labor-ticket/${machineRef}/program-events/${eventId}/merge`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(apiKey),
      },
      body: JSON.stringify({
        sourceEventRefs: [eventId],
        targetWorkOrderOperationRef,
      }),
    }
  );
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `merge failed: ${res.status}`);
  }
};
